import { combineReducers } from 'redux';
import {
  userLogin,
  userLogout,
  getUsers,
  deleteUsers,
  addNewUsers,
  updateUsers,
  getPageUsers,
  getLogedInUser,
  forgotPassword,
  resetPassword,
  getManagers,
  getRelatedAgent,
} from 'actions/users';
import { emptyState } from 'configs/localStorage';

const user = () => {
  const initialState = {
    loggedInUser: null,
  };

  return (state = initialState, {
    type, error, record, loggedInUser,
  }) => {
    switch (type) {
      case userLogin.requestTypes.SUCCESS:
        return {
          ...state,
          loggedInUser,
        };
      case getLogedInUser.requestTypes.SUCCESS:
        return {
          ...state,
          loggedInUser: {
            ...state.loggedInUser,
            data: loggedInUser.data[0],
          },
        };
      case userLogout.requestTypes.SUCCESS:
        emptyState();
        return initialState;
      case userLogout.requestTypes.FAILURE:
        emptyState();
        return initialState;
      case forgotPassword.requestTypes.SUCCESS:
        return {
          ...state,
          isForgotPasswordEmailSuccess: true,
        };
      case forgotPassword.requestTypes.REQUEST:
        return {
          ...state,
          isForgotPasswordEmailSuccess: false,
        };
      case resetPassword.requestTypes.SUCCESS:
        return {
          ...state,
          isResetPasswordSuccess: true,
        };
      case resetPassword.requestTypes.REQUEST:
        return {
          ...state,
          isResetPasswordSuccess: false,
        };
      default:
        return state;
    }
  };
};

const relatedUsers = () => {
  const initialState = {};
  return (state = initialState, action) => {
    const { type, response, ids } = action;
    switch (type) {
      case getPageUsers.requestTypes.SUCCESS:
      case getUsers.requestTypes.SUCCESS:
        return {
          ...response,
        };
      case deleteUsers.requestTypes.SUCCESS:
        return {
          ...state,
          total: state.total - ids.length,
        };
      case addNewUsers.requestTypes.REQUEST:
      case updateUsers.requestTypes.REQUEST:
        return {
          ...state,
          isSuccessful: false,
        };
      case addNewUsers.requestTypes.SUCCESS:
      case updateUsers.requestTypes.SUCCESS:
        return {
          ...state,
          isSuccessful: true,
        };
      case addNewUsers.requestTypes.FAILURE:
      case updateUsers.requestTypes.FAILURE:
        return {
          ...state,
          isSuccessful: false,
        };
      default:
        return state;
    }
  };
};

const allManagers = () => {
  const initialState = {};
  return (state = initialState, action) => {
    const { type, response } = action;
    switch (type) {
      case getManagers.requestTypes.SUCCESS:
        return {
          ...response,
        };
      default:
        return state;
    }
  };
};

const getRelatedAgents = () => {
  const initialState = {};
  return (state = initialState, action) => {
    const { type, response } = action;
    switch (type) {
      case getRelatedAgent.requestTypes.REQUEST:
        return {};
      case getRelatedAgent.requestTypes.SUCCESS:
        return {
          ...response,
        };
      default:
        return state;
    }
  };
};

const userRoles = () => {
  const initialState = {
    selectedUser: {},
  };

  return (state = initialState, {
    type, error, record,
  }) => {
    switch (type) {
      case 'TEST_ACTION':
        return {
          ...initialState,
          selectedUser: record,
        };
      default:
        return state;
    }
  };
};

export default combineReducers({
  user: user(),
  relatedUsers: relatedUsers(),
  userRoles: userRoles(),
  allManagers: allManagers(),
  getRelatedAgents: getRelatedAgents(),
});
